import React from 'react';
import CustomHead from '../components/CustomHead';
import DownloadSection from '../components/DownloadSection';
import StandardLayout from '../components/StandardLayout';
import { Container } from '../components/Container';

export default function DownloadPage({}) {
  return (
    <StandardLayout
      head={
        <CustomHead
          title="TopHouse - Download"
          description="How to download the TopHouse app"
        />
      }
      showStandardDownloadSection={false}
    >
      <Container>
        <DownloadSection className="border-0 mt-0" />
      </Container>
    </StandardLayout>
  );
}
